import React, { useCallback } from 'react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { GridColumnMenuItemProps, useGridApiContext } from '@mui/x-data-grid-pro';
import Icon from '@mdi/react';
import { mdiFilter } from '@mdi/js';
import { useTranslation } from 'react-i18next';

export default (props: GridColumnMenuItemProps) => {
    const { onClick, colDef } = props;
    const { t } = useTranslation('translations', { keyPrefix: 'docTable' });
    const apiRef = useGridApiContext();
    const handleClick = useCallback(
        (event: React.MouseEvent<HTMLElement>) => {
            event.preventDefault();
            apiRef.current.showFilterPanel(colDef.field);
            onClick(event);
        },
        [apiRef, colDef.field, onClick],
    );
    return (
        <MenuItem onClick={handleClick}>
            <ListItemIcon>
                <Icon path={mdiFilter} size={1} />
            </ListItemIcon>
            <ListItemText>{t('advancedFilter')}</ListItemText>
        </MenuItem>
    );
};
